import React from 'react';
import Icon from '../Icon';

interface GlobalRefreshButtonProps {
  onRefresh: () => void;
  /** Disables the button and spins the icon while the data is being read again. */
  busy?: boolean;
  /** Tooltip; the accessible name is always "Refresh". */
  title?: string;
  className?: string;
}

/**
 * The icon-only Refresh in the global header, next to search, the bell and the
 * avatar. One component for the project header and the account header; pages
 * never draw their own (see hooks/usePageRefresh.ts and refreshButton.contract.test.ts).
 */
const GlobalRefreshButton: React.FC<GlobalRefreshButtonProps> = ({ onRefresh, busy = false, title = 'Refresh', className = '' }) => (
  <button
    type="button"
    className={`global-header-icon-btn global-refresh-btn${busy ? ' syncing' : ''}${className ? ` ${className}` : ''}`}
    onClick={onRefresh}
    disabled={busy}
    aria-busy={busy || undefined}
    title={title}
    aria-label="Refresh"
  >
    <Icon name="refresh" size={20} />
  </button>
);

export default GlobalRefreshButton;
